// extracted by mini-css-extract-plugin
module.exports = {"root":"CircleProgressBar_root__1OtJ1"};